export default "__VITE_ASSET__CE95$pUc__"